import React from 'react';
import { audiLightTheme } from '../../themes';
import { ThemeProvider } from '../ThemeProvider';
import { GlobalStyles } from '../GlobalStyles';
export var AudiPlatformProvider = function AudiPlatformProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? audiLightTheme : _ref$theme,
      fontUrl = _ref.fontUrl,
      iconFontUrl = _ref.iconFontUrl,
      children = _ref.children;
  return React.createElement(React.Fragment, null, React.createElement(GlobalStyles, {
    fontUrl: fontUrl,
    iconFontUrl: iconFontUrl
  }), React.createElement(ThemeProvider, {
    theme: theme
  }, children));
};